import React from "react";
import "./AccountType.css";

const AccountType = () => {
  return (
    <div className="main-content">
      <div className="breadcrumb">
        Home / <span>View All</span>
      </div>

      <div className="page-header">
        <div>
          <h2>Account Type List</h2>
          <p className="subtitle">View all account types</p>
        </div>
        <div className="header-buttons">
          <button className="btn blue">+ Create New</button>
        </div>
      </div>

      <div className="card">
        <div className="top-controls">
          <div className="search-box">
            Search: <input type="text" />
          </div>
        </div>

        <div className="buttons">
          <button>Copy</button>
          <button>CSV</button>
          <button>Excel</button>
          <button>PDF</button>
          <button>Print</button>
          <button className="dropdown">Column visibility ▾</button>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Account Type</th>
                <th>Nextgn Group</th>
                <th>Min.First Deposite</th>
                <th>Internal Transfer</th>
                <th>First Deposite Bonus</th>
                <th>100% Bonus</th>
                <th>Show/Hide</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="11" className="empty">
                  No data available in table
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <p>Showing 0 to 0 of 0 entries</p>
          <div>
            <button disabled>Previous</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      <footer>
        <p>
          Copyright © 2025{" "}
          <span className="brand">Ample Markets</span>. All rights reserved.{" "}
          <span className="version">Version 2.0</span>
        </p>
      </footer>
    </div>
  );
};

export default AccountType;
